import { ChevronRight } from "react-feather";

interface AuthSwitchLinkProps {
  onClick: () => void;
  /** Lead-in copy, e.g. "Don't have an account? " (keep the trailing space). */
  prompt: string;
  /** The emphasised action word, e.g. "Sign up". */
  action: string;
  /** Spacing override — placement differs between the chooser and the form. */
  className?: string;
}

// Footer link that switches between the sign-in / sign-up flows. Mirrors the
// mobile AuthSwitchLink: the whole label is terracotta, the action word bold, with
// a trailing chevron, centred.
export function AuthSwitchLink({
  onClick,
  prompt,
  action,
  className = "mt-4",
}: AuthSwitchLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-center justify-center gap-1 text-sm font-semibold text-terracotta transition hover:text-terracotta-dark cursor-pointer ${className}`}
    >
      <span>
        {prompt}
        <span className="font-bold">{action}</span>
      </span>
      <ChevronRight className="h-4 w-4" strokeWidth={2.5} />
    </button>
  );
}
